import Helper from './Helper';

class Search {
  constructor(config = {}) {

      const params = new URLSearchParams(window.location.search);
      const keyword = params.get("highlight");

      if (keyword) {
        const safeKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${safeKeyword})`, 'gi');
        const highlightTemplate = `<span style="color:#ffffff;background:#637a52;padding-right:4px;padding-left:4px">$1</span>`;

        const contentSelectors = ['.ns-title-h1', '.ns-title-h2', '.ns-title-h3', '.ns-paragraph'];

        contentSelectors.forEach(selector => {
          document.querySelectorAll(selector).forEach(element => {
            element.innerHTML = element.innerHTML.replace(regex, highlightTemplate);
          });
        });
      }

  }
}

export default Search;
